var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9959 0.474736C41.9052 0.21256 54.2042 12.0865 54.4664 26.9959C54.7286 41.9052 42.8547 54.2042 27.9453 54.4664C13.0359 54.7286 0.736927 42.8547 0.474751 27.9453C0.212574 13.0359 12.0865 0.736913 26.9959 0.474736Z",
    fill: "#ACBBCD",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8383 23.5143L12.4706 49.4705L35.14 25.682L24.8383 23.5143Z",
    fill: "#2D66AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8383 23.5143L12.4706 49.4705L30.8813 24.7867L24.8383 23.5143Z",
    fill: "#3D79BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4746 20.914L35.1399 25.682L46.4705 13.7942L12.4746 20.914Z",
    fill: "#DB2328"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4789 20.9055L33.0455 21.8822L46.4707 13.7942L12.4789 20.9055Z",
    fill: "#EF434D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3148 5.47052C32.5297 5.46967 31.7619 5.71317 31.1087 6.17019C30.4555 6.62722 29.9462 7.27724 29.6452 8.03803C29.3442 8.79882 29.265 9.63619 29.4177 10.4442C29.5704 11.2522 29.948 11.9946 30.5029 12.5773C31.0578 13.1601 31.7649 13.5571 32.5349 13.7181C33.3049 13.8791 34.1031 13.7969 34.8285 13.4819C35.554 13.1668 36.1741 12.6331 36.6103 11.9483C37.0466 11.2634 37.2795 10.4582 37.2795 9.63448C37.2795 8.53087 36.8619 7.4724 36.1185 6.69163C35.3751 5.91086 34.3667 5.47166 33.3148 5.47052",
    fill: "#EF434D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2566 8.33216C30.2504 7.72456 30.3732 7.12313 30.6159 6.57147C30.1911 6.98996 29.8594 7.50155 29.6445 8.06984C29.4296 8.63813 29.3367 9.24914 29.3725 9.85937C29.4082 10.4696 29.5718 11.0641 29.8515 11.6004C30.1312 12.1368 30.5201 12.6019 30.9906 12.9626C31.4611 13.3233 32.0016 13.5708 32.5737 13.6874C33.1457 13.8039 33.7352 13.7868 34.3002 13.6371C34.8652 13.4875 35.3918 13.209 35.8426 12.8215C36.2933 12.4339 36.6571 11.947 36.908 11.3952C36.3406 11.9411 35.6341 12.3022 34.8746 12.4343C34.115 12.5664 33.3353 12.4639 32.6303 12.1393C31.9253 11.8146 31.3256 11.2819 30.9041 10.6059C30.4826 9.92992 30.2577 9.13992 30.2566 8.33216",
    fill: "#DB2328"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsLogo);
export default __webpack_public_path__ + "static/media/ks-logo.1d4c139c922beab09ac6090774fbef44.svg";
export { ForwardRef as ReactComponent };